import { render } from "./TabSelector.vue?vue&type=template&id=f1bc85e8&scoped=true"
import script from "./TabSelector.vue?vue&type=script&lang=js"
export * from "./TabSelector.vue?vue&type=script&lang=js"

import "./TabSelector.vue?vue&type=style&index=0&id=f1bc85e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1bc85e8"]])

export default __exports__